// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Theme } from '@mui/material/styles';

// Centred where the folder page shows its own empty state.
const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(2),
    marginTop: '20vh',
    padding: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  icon: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    color: theme.palette.text.secondary,
  },
});

export default styles;
